module.exports = __webpack_public_path__ + "img/services-rhomb.b7bab498.png";